<div class="coverage-proposal-page">
    <div class="container">
        <div class="info-content">
            <div class="info">
                <div class="portalLogo"></div>
                <h3 class="my-5">{{headerText}}</h3>
                <self-ins-policies-and-request-page></self-ins-policies-and-request-page>
                <p *ngIf="!user || user.status !== 'active'">Please review the coverage terms and click the Enroll Now at the bottom of the page. If you have any
                    questions, feel free to contact our support team at
                    <a href="mailto:AFPsupport@mcgriff.com?subject={{user?.verificationInfo?.insuredName ? user?.verificationInfo?.insuredName : ''}}">
                        AFPsupport@mcgriff.com
                    </a>
                </p>
            </div>
            <div class="contacts">
                <p class="m-0">Contact us:</p>
                <div>
                    <a href="mailto:AFPsupport@mcgriff.com?subject={{user?.verificationInfo?.insuredName ? user?.verificationInfo?.insuredName : ''}}">
                        AFPsupport@mcgriff.com
                    </a>
                    <span></span>
                    <a href="tel:+18448186243">844-818-6243</a>
                </div>
            </div>
            <div class="footer mt-2">
                <a
                    href="https://www.marshmma.com/us/privacy-notice.html"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Notice
                </a>
            </div>
        </div>
        <div class="main-content" *ngIf="pdfContent">
            <div class="pdf-cont">
                <pdf-viewer [src]="pdfContent"
                    [render-text]="true"
                    [original-size]="false"
                    class="d-flex h-100 w-100"
                ></pdf-viewer>
            </div>
            <div class="actions pt-3">
                <button [routerLink]="user?.status === 'active' ? ['/coverage'] : ['/verification-drivers']"
                        [queryParams]="{ qnum: qnum, qsuffix: qsuffix }"
                        class="primary-button">
                    Go back
                </button>
                <div *ngIf="!user || user.status !== 'active'">
                    <button (click)="enroll()" class="primary-button ms-3">
                        Enroll Now
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
